import { ApplicationsServiceClient } from '@pushwoosh/rpc-service-client/pushwoosh/applications/ApplicationsServiceClientPb';
import {
  Application,
  ApplicationSummary,
  ApplicationPermissions,
  ApplicationPlatformSubscribersCount,
  GetApplicationRequest,
  GetApplicationResponse,
  CreateApplicationRequest,
  CreateApplicationResponse,
  UpdateApplicationRequest,
  UpdateApplicationResponse,
  ListApplicationsRequest,
  ListApplicationsResponse,
  DeleteApplicationRequest,
  DeleteApplicationResponse,
  SetShortenerConfigurationRequest,
  SetShortenerConfigurationResponse,
} from '@pushwoosh/rpc-service-client/pushwoosh/applications/applications_pb';

export type ApplicationsExportClasses = {
  ApplicationsServiceClient: typeof ApplicationsServiceClient;
  Application: typeof Application;
  ApplicationSummary: typeof ApplicationSummary;
  ApplicationPermissions: typeof ApplicationPermissions;
  ApplicationPlatformSubscribersCount: typeof ApplicationPlatformSubscribersCount;
  GetApplicationRequest: typeof GetApplicationRequest;
  GetApplicationResponse: typeof GetApplicationResponse;
  CreateApplicationRequest: typeof CreateApplicationRequest;
  CreateApplicationResponse: typeof CreateApplicationResponse;
  UpdateApplicationRequest: typeof UpdateApplicationRequest;
  UpdateApplicationResponse: typeof UpdateApplicationResponse;
  ListApplicationsRequest: typeof ListApplicationsRequest;
  ListApplicationsResponse: typeof ListApplicationsResponse;
  DeleteApplicationRequest: typeof DeleteApplicationRequest;
  DeleteApplicationResponse: typeof DeleteApplicationResponse;
  SetShortenerConfigurationRequest: typeof SetShortenerConfigurationRequest;
  SetShortenerConfigurationResponse: typeof SetShortenerConfigurationResponse;
};

export const applications: ApplicationsExportClasses = {
  ApplicationsServiceClient,
  Application,
  ApplicationSummary,
  ApplicationPermissions,
  ApplicationPlatformSubscribersCount,
  GetApplicationRequest,
  GetApplicationResponse,
  CreateApplicationRequest,
  CreateApplicationResponse,
  UpdateApplicationRequest,
  UpdateApplicationResponse,
  ListApplicationsRequest,
  ListApplicationsResponse,
  DeleteApplicationRequest,
  DeleteApplicationResponse,
  SetShortenerConfigurationRequest,
  SetShortenerConfigurationResponse,
};
